export const APP_NAME = 'Unite';
export const STORE_KEY = 'unite_store';

export const xHeaders = {
    'secure-tokens': 'X-Secure-Tokens',
    'trace-id': 'X-Trace-Id',
} as const;

export const defaultPagination = {
    page: 0,
    perPage: 15,
};

export const notificationUri = '/assets/notification.mp3';

export const techSupportLink = 'https://telegram.me/Sup_Plat';
